import React, { useEffect, useState } from "react";
import axios from "axios";

import styled from "styled-components";

import { Button } from "antd";

import { handleError } from "../../../modules/presence/sagas";
import { Link } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const Referentiel = () => {
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30, width: "30%" }}>{`Référentiel`}</div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-around" }}></div>
      </HeaderContainer>
      <React.Fragment>
        <div className="flex flex-wrap justify-around items-center h-screen w-full">
          <Link to={{ pathname: `/ref/brands` }}>
            <div className="px-8 py-4 bg-orange-500 text-white text-3xl rounded hover:bg-orange-700">marques</div>
          </Link>
          <Link to={{ pathname: `/ref/families` }}>
            <div className="px-8 py-4 bg-orange-500 text-white text-3xl rounded hover:bg-orange-700">familles</div>
          </Link>
          <Link to={{ pathname: `/imports/actions` }}>
            <div className="px-8 py-4 bg-orange-500 text-white text-3xl rounded hover:bg-orange-700">actions</div>
          </Link>
          <Link to={{ pathname: `/ref/retailers` }}>
            <div className="px-8 py-4 bg-orange-500 text-white text-3xl rounded hover:bg-orange-700">enseignes</div>
          </Link>
          <Link to={{ pathname: `/ref/ranges` }}>
            <div className="px-8 py-4 bg-orange-500 text-white text-3xl rounded hover:bg-orange-700">strates</div>
          </Link>
          <Link to={{ pathname: `/ref/sectors` }}>
            <div className="px-8 py-4 bg-orange-500 text-white text-3xl rounded hover:bg-orange-700">secteurs</div>
          </Link>
        </div>
      </React.Fragment>
    </Container>
  );
};

export default Referentiel;



// WEBPACK FOOTER //
// src/containers/metier/referential/Referential.js